export const getProductImageSrc = (productData, mainCategoryId) => {
  // Enhanced error handling
  if (!productData) {
    console.warn('getProductImageSrc: No product data provided');
    return '📦';
  }

  const category = mainCategoryId || productData.mainCategoryId;
  const name = productData.name;
  const attributes = productData.attributes;

  if (!category) {
    console.warn('getProductImageSrc: No category provided for product:', name);
    return '📦';
  }

  if (!name) {
    console.warn('getProductImageSrc: No product name provided for category:', category);
    return '📦';
  }

  // Poles Logic
  if (category === 'poles') {
    const poleType = attributes?.poleType;
    if (poleType === 'Lockhead Pole') return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/poles/Poles%20Section.avif";
    if (poleType === 'Springhead Pole') return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/poles.images/Springhead-section.avif";
    if (poleType === 'Rolling Springhead Pole') return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/poles.images/Rolling%20Springhead%20Section.avif";
    if (poleType === 'Flow Pole') return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/poles.images/Flow-Section.avif";
    return '🏗️';
  }

  // Decks Logic
  if (category === 'decks') {
    if (name.includes('Food Grade') && name.includes('No Slide')) return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/decks.images/Food%20Grade%20No%20Slide.avif";
    if (name.includes('Food Grade') && name.includes('Powder Unloading Station Adapted')) return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/decks.images/Deck%20Food%20Grade.avif";
    if (name.includes('Food Grade') && name.includes('open sides')) return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/decks.images/Deck%20Food%20Grade.avif";
    if (name.includes('Food Grade') && !name.includes('open sides')) return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/decks.images/Deck%20Food%20Grade.avif";
    if (name.includes('Standard') && name.includes('open sides') && name.includes('Stainless Steel')) return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/decks.images/Deck%20Open%20Sides.avif";
    if (name.includes('Standard') && name.includes('open sides')) return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/decks.images/Deck%20Open%20Sides.avif";
    if (name.includes('Standard') && name.includes('Stainless Steel')) return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/decks.images/Deck%20Standard.avif";
    if (name.includes('Standard') && name.includes('No Slide')) return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/decks.images/Deck%20No%20Slide.avif";
    if (name.includes('Standard') && name.includes('Powder Unloading Station Adapted')) return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/decks.images/Deck%20Standard.avif";
    if (name.includes('open sides')) return "https://i.imgur.com/yKRYKYn.png";
    if (name.includes('Standard')) return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/decks.images/Deck%20Standard.avif";
    return "https://i.imgur.com/fUHm6LO.png";
  }

  // Unloading Stations Logic
  if (category.startsWith('unloading_stations')) {
    if (name === 'Unloading Station | Frame Base | Stainless Steel') return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/unloadingstation/Base-Frame-Stainless-Steel.png";
    if (name.includes('Frame Base')) return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/unloadingstation/Frame-Base.avif";
    if (name === 'Filling Support Bars | Round | Add-on | Stainless Steel') return "https://i.imgur.com/u4fRjbj.png";
    if (name === 'Filling Support Bars | Round | Add-on') return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/unloadingstation/Filling%20Support%20Bars.avif";
    if (name === 'Modular Station Add-on Carrier | Stainless Steel') return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/Spare%20Parts/Carrier%20Stainless.avif";
    if (name === 'Modular Station Add-on Carrier') return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/Spare%20Parts/Carrier.avif";
    if (name === 'Big Bag Piercer') return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/unloadingstation/Piercer.webp";
    if (name === 'Granulate Hopper | Unloading Station | Add-on') return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/unloadingstation/Hopper-v1.avif";
    if (name.includes('Wheelset | Feet set') && name.includes('Stainless Steel')) return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/unloadingstation/Wheel%20Set%20Stainless.avif";
    if (name.includes('Wheelset | Feet set')) return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/unloadingstation/Wheel%20Set.avif";
    if (name.includes('Feet set Large') && name.includes('Stainless Steel')) return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/unloadingstation/Feet%20Set%20Large%20Stainless.avif";
    if (name.includes('Feet set Medium') && name.includes('Stainless Steel')) return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/unloadingstation/Medium%20Stainless%20Feet.avif";
    if (name.includes('Feet set') && name.includes('Stainless Steel')) return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/unloadingstation/Feet%20Set%20Small%20Stainless.avif";
    if (name.includes('Wheelset') && name.includes('Stainless Steel')) return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/unloadingstation//Wheelset%20Stainless.png";
    if (name.includes('Wheelset')) return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/unloadingstation/Wheel%20Set.avif";
    if (name.includes('Feet set Small')) return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/unloadingstation//Unloading%20Station%20-%20Feet%20Small%20-%2014-4.png";
    if (name.includes('Feet set Medium')) return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/unloadingstation/Feet%20Set%20Medium.avif";
    if (name.includes('Feet set Large')) return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/unloadingstation/Feet%20Set%20Large.avif";
    if (name.includes('Feet set')) return "https://i.imgur.com/oaHJa69.png";
    if (name === 'Manual Dosed Discharger | Add-on') return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/unloadingstation/Manual%20Dosed%20Discharger%20Set.avif";
    if (name.includes('Manual Dosed Discharger Set')) return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/unloadingstation/Manual%20Dosed%20Discharger%20Set.avif";
    if (name === 'Throttle Valve') return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/unloadingstation/throttle-valve.webp";
    if (name === 'Pipe Regulator Gates') return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/unloadingstation/Pipe%20regulator%20gates%20.avif";
    if (name === 'Vibrating Platform | Add-on') return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/unloadingstation/Trilstation%208-7%20Supabase.avif";
    if (name === 'Pneumatic Unloader') return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/unloadingstation/Pneumatic%20Unloader%20Buckets.png";
    if (name === 'Pneumatic Pushers') return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/unloadingstation/Pneumatic-pushers.avif";
    if (name === 'Pneumatic Slide') return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/unloadingstation/slide-add-on.avif";
    if (name === 'Manual Control Panel | Add-on') return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/unloadingstation/Manual%20Control%20Panel%20(2).avif";
    if (name === 'Dust Free Pipe | Add-on') return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/unloadingstation/Dust_containment_pipe.webp";
    if (name === 'Vacuum Container | Add-on') return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/unloadingstation/Granulate_Hopper_Full.webp";
    if (name === 'Cleaning Pipe | Add-on') return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/unloadingstation/Cleaning_Pipe_Detailed.webp";
    if (name === 'Magnetic Separator | Add-on') return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/unloadingstation/magnetic-seperator.webp";
    return "https://i.imgur.com/A7PYa9k.png";
  }

  // Big Bags Logic
  if (category === 'big_bags') {
    return "https://i.imgur.com/xVPvy68.png";
  }

  // Spare Parts Logic
  if (category === 'spare_parts') {
    const nameLower = name.toLowerCase();
    if (name === 'Modular Station Add-on Carrier | Stainless Steel') return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/Spare%20Parts/Carrier%20Stainless.avif";
    if (name === 'Modular Station Add-on Carrier') return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/Spare%20Parts/Carrier.avif";
    if (name === 'Manual Dosed Discharger | Add-on') return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/Spare%20Parts/Manual%20Dosed%20Discharger.avif";
    if (nameLower.includes('lock')) return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/Spare%20Parts/Lock.avif";
    if (nameLower.includes('slide')) return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/Spare%20Parts/Slide.avif";
    if (nameLower.includes('rolling springhead') && nameLower.includes('roll')) return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/Spare%20Parts/Roll%20Mechanism.avif";
    if (nameLower.includes('springhead') && nameLower.includes('replacement')) return "https://ruylodmxakyicasoszik.supabase.co/storage/v1/object/public/Spare%20Parts/Springhead%20Vervangingskit.avif";
    return '🔧';
  }

  // Enhanced fallback logic with category-specific emojis
  const categoryFallbacks = {
    'poles': '🏗️',
    'decks': '🏢', 
    'unloading_stations': '🏭',
    'big_bags': '👜',
    'spare_parts': '🔧'
  };
  
  return categoryFallbacks[category] || '📦';
};

// Helper function to validate if an image URL is accessible (for future use)
export const validateImageUrl = async (url) => {
  try {
    const response = await fetch(url, { method: 'HEAD' });
    return response.ok;
  } catch (error) {
    console.warn('Image validation failed for URL:', url, error);
    return false;
  }
};

// Helper function to get fallback image for a category
export const getCategoryFallback = (category) => {
  const fallbacks = {
    'poles': '🏗️',
    'decks': '🏢', 
    'unloading_stations': '🏭',
    'big_bags': '👜',
    'spare_parts': '🔧'
  };
  
  return fallbacks[category] || '📦';
};
